// Helpers for the admin pages whose Stimulus controllers render from
// /admin/api/v1 (the Tract Report lab and contributions admin): JSON calls,
// HTML escaping and date labels.

export function esc(value) {
    return String(value == null ? "" : value)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

// Rejects with the API's `error` message on a non-2xx response.
export function request(method, url, body) {
    const tokenTag = document.querySelector('meta[name="csrf-token"]');
    const headers = { Accept: "application/json" };
    if (body) headers["Content-Type"] = "application/json";
    if (tokenTag) headers["X-CSRF-Token"] = tokenTag.content;
    return fetch(url, { method, headers, credentials: "same-origin", body: body ? JSON.stringify(body) : undefined })
        .then(response => response.json().catch(() => ({})).then(data => {
            if (!response.ok) throw new Error(data.error || response.status + " " + response.statusText);
            return data;
        }));
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-08" => "Aug 2026"
export function monthLabel(ym) {
    if (!ym) return "";
    const parts = ym.split("-");
    return MONTHS[Number(parts[1]) - 1] + " " + parts[0];
}

// "2026-08-03" => "Aug 3, 2026"
export function dateLabel(iso) {
    if (!iso) return "";
    const parts = iso.split("-");
    return MONTHS[Number(parts[1]) - 1] + " " + Number(parts[2]) + ", " + parts[0];
}
